<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link to="/dashboardUser" name="Home" icon="ti-panel" />
        <sidebar-link to="/stockout_user" name="Stockout" icon="ti-package" />
        <sidebar-link
          to="/purchase_order_user"
          name="Purchase Order"
          icon="ti-credit-card"
          v-if="this.$store.getters.getAccessLevel == 2"
        />
        <sidebar-link
          to="/delivery_order_user"
          name="Delivery Order"
          icon="ti-export"
          v-if="this.$store.getters.getAccessLevel == 2"
        />
        <sidebar-link
          to="/mf_user"
          name="Monthly Forecast"
          v-if="this.$store.getters.getAccessLevel == 2"
          icon="ti-menu"
        />
        <sidebar-link
          to="/sub_dealer_user"
          :name="name"
          icon="ti-user"
          v-if="
            this.$store.getters.getAccessLevel == 2 ||
              this.$store.getters.getAccessLevel == 3
          "
        />
        <sidebar-link
          to="/outlet_history_name_user"
          name="OUTLET NAME HISTORY"
          icon="ti-book"
          v-if="
            this.$store.getters.getAccessLevel == 2 ||
              this.$store.getters.getAccessLevel == 3 ||
                this.$store.getters.getAccessLevel == 4
          "
        />
        <sidebar-link to="/logout" name="Logout" icon="ti-shift-left" />
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"></dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbarUser.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent
  },

  data() {
    return {
      name: "Home Dealer"
    };
  },

  created() {
    if (this.$store.getters.getAccessLevel == 3) {
      this.name = "Agent";
    }
  },

  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    onClickPush() {
      this.$router.push({ path: `/setting` });
    }
  }
};
</script>
